// STICKY HEADER AND ATC ON PDPs

window.addEventListener("scroll", function () {
  var header = document.getElementById("MainHeader");
  var pageIsProduct = Boolean(document.querySelector(".template-product"));
  var sticky = header.offsetTop;

  if (window.pageYOffset > sticky) {
    header.classList.add("v-menu-sticky");
  } else {
    header.classList.remove("v-menu-sticky");
  }

  if (pageIsProduct) {
    // STICKY ATC
    var stickyAddToCart = document.querySelector(".v-sticky-add-to-cart");
    if (window.pageYOffset > 100) {
      stickyAddToCart.style.opacity = "0.95";
      stickyAddToCart.style.pointerEvents = "auto";
    } else {
      stickyAddToCart.style.opacity = "0";
      stickyAddToCart.style.pointerEvents = "none";
    }
  }
});

window.addEventListener("DOMContentLoaded", (event) => {
  if (document.querySelector(".v-sticky-add-to-cart__btn").innerText == "ADD TO CART") {
    document.querySelector(".v-sticky-add-to-cart__btn").addEventListener("click", function () {
        document.querySelector("form[action='/cart/add']").submit();
      });
  }
});

// END

// SYNC TWO QUANTITY INPUTS TO PREVENT BUGS. ONE IS FOR DESKTOP THE OTHER ONE FOR MOBILE
window.addEventListener("DOMContentLoaded", (event) => {
  var quantityInputs = document.querySelectorAll(
    ".product__content .quantity__input"
  );
  function syncQuantityInputs(event) {
    var sourceInput = event.target;
    quantityInputs.forEach(function (input) {
      if (input !== sourceInput) {
        input.value = sourceInput.value;
      }
    });
  }
  quantityInputs.forEach(function (input) {
    input.addEventListener("change", syncQuantityInputs);
  });
});


